import React, {FunctionComponent, useState, useMemo} from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache, ApolloLink, HttpLink, from } from '@apollo/client';
import { useAuth } from '../auth/auth-provider';

export { gql, useQuery } from '@apollo/client';

const Client = (link: ApolloLink) => new ApolloClient({
  cache: new InMemoryCache(),
  link
});

const httpLink = new HttpLink({
  uri: `${process.env.GRAPHQL_ENDPOINT || 'https://data.fortfa.com'}/v1/graphql`,
});

export const GraphQLProvider: FunctionComponent = ({children}) => {
  const {token} = useAuth();

  const authLink = useMemo(() => {
    return new ApolloLink((operation, forward) => {
    if (token) {
      operation.setContext(({headers}: {headers: {[key: string]: string}}) => ({ headers: {
        authorization: `Bearer ${token}`,
        ...headers
      }}))
    }

    return forward(operation);
  })}, [token]);

  const client = useMemo(() => Client(from([authLink, httpLink])), [authLink]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>
};
